export function sortDatesAsc (a, b) {
  var dateA = new Date(a)
  var dateB = new Date(b)
  return dateA - dateB
}

export function sortDatesDesc (a, b) {
  var dateA = new Date(a)
  var dateB = new Date(b)
  return dateB - dateA
}
